import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button, Typography, Paper, Tabs, Tab, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { fetchErrors } from '../api';
import { useTranslation } from 'react-i18next';

const TAIL_OPTIONS = [100, 200, 500, 1000];

const ErrorLogPage = () => {
  const { t } = useTranslation();
  const [lines, setLines] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('processing');
  const [tail, setTail] = useState(500);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetchErrors(activeTab, tail);
      setLines(res.lines || []);
    } catch (e) {
      console.error(t('errorsPage.errors.fetchFailed'), e);
    } finally {
      setLoading(false);
    }
  }, [activeTab, tail, t]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, mb: 2, flexWrap: 'wrap' }}>
        <Typography variant="h5">{t('errorsPage.title')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <FormControl size="small" sx={{ minWidth: 140 }}>
            <InputLabel id="errors-tail-select-label">{t('errorsPage.controls.show')}</InputLabel>
            <Select
              labelId="errors-tail-select-label"
              value={tail}
              label={t('errorsPage.controls.show')}
              onChange={(event) => setTail(event.target.value)}
            >
              {TAIL_OPTIONS.map((option) => (
                <MenuItem key={option} value={option}>
                  {t('errorsPage.controls.lastLines', { count: option })}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button onClick={load} disabled={loading} variant="contained">{t('errorsPage.actions.refresh')}</Button>
        </Box>
      </Box>

      <Box sx={{ mb: 2, p: 2, bgcolor: 'action.hover', borderRadius: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {t('errorsPage.intro.overview')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {t('errorsPage.intro.adminUse')}
        </Typography>
      </Box>

      <Tabs
        value={activeTab}
        onChange={(_, value) => setActiveTab(value)}
        sx={{ mb: 2 }}
      >
        <Tab value="processing" label={t('errorsPage.tabs.processing')} />
        <Tab value="application" label={t('errorsPage.tabs.application')} />
      </Tabs>

      <Paper sx={{ p: 2, maxHeight: '60vh', overflow: 'auto' }}>
        {lines.length === 0 && <Typography>{t(`errorsPage.emptyBySource.${activeTab}`)}</Typography>}
        {lines.map((l, i) => (
          <Typography key={i} sx={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap' }}>{l}</Typography>
        ))}
      </Paper>
    </Box>
  );
};

export default ErrorLogPage;
